// extracted by mini-css-extract-plugin
module.exports = {"container":"BreadcrumbRest_container__wWV0o","divider":"BreadcrumbRest_divider__4w_IK"};